import { BaseEntity } from "./common";

export interface User extends BaseEntity {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  organization: string;
  role: UserRole;
  avatar?: string;
  isVerified: boolean;
  uid?: number; // Numeric user ID from USER.SETTINGS
}

export enum UserRole {
  ADMIN = "admin",
  USER = "user",
  MODERATOR = "moderator",
}
